var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_vm._v(" © 2022, Ganwan (Beijing) Technology Co., Ltd. ALL RIGHTS RESERVED. 敢玩（北京）科技有限公司 京ICP备15004334号-1 ")])}
var staticRenderFns = []

export { render, staticRenderFns }